// 1. 외부 패키지
import { useEffect } from 'react'
import { useRecoilState } from 'recoil'

// 2. 프로젝트 내부 alias
import useScrollControl from '../../hooks/use-scroll-control'

// 3. 상대 경로
import Main from '../../components/layout/main'
import Basic from '../../components/basic'
import ErrorBoundary from '../../components/layout/error-boundary'
import ErrorBoundaryFallbackReturn from '../../components/layout/error-boundary-fallback-return'
import basic_detail_atom from '../../atom/basic-detail'
import DeclarePopup from '../../components/popup/declare-popup'
import RegisterPopup from '../../components/popup/register-popup'
import SharePopup from '../../components/popup/share-popup'

// 4. 타입


const SaleDetailTypeBasic = () => {

  const [basic_detail, setBasicDetail] = useRecoilState(basic_detail_atom);

  const { popup } = basic_detail;

  const setPopup = (e: number) => {
    setBasicDetail({
      ...basic_detail,
      popup: e,
    });
  };


  useEffect(() => {
    window.scrollTo({ top: 0 })
  }, [])

  useScrollControl()

  return (
    <ErrorBoundary
      fallback={
        <ErrorBoundaryFallbackReturn
          message='조회할 수 없는 정보입니다.'
        />
      }
    >
    <Basic.BasicMobileGnbWrapper />
    <Main id='sale_detail'>
      <div className='container'>
          <div className='inner for_type2 pb-zero'>
            <div className='detail_card'>
              <Basic.LeftWrapper />
              <Basic.RightWrapper name='basic'/>
            </div>
            <div className='detail_desc'>
              <div className='desc_text'>
                <Basic.TopWrapper />
                <Basic.BottomWrapper />
                <Basic.Notice />
                <Basic.TableWrapper />
              </div>
              <Basic.MobileBottomCardWrapper />
            </div>
            <div id='type' className='detail_bottom_wrap type4'>
              <Basic.DetailWrapper />
              <Basic.PriceInfoWrapper />
              <Basic.NewsWrapper />
            </div>
          </div>
      </div>
    </Main>
      {popup === 1 && <DeclarePopup onClickClose={() => setPopup(0)} />}
      {popup === 2 && <RegisterPopup onClickClose={() => setPopup(0)} />}
      {popup === 3 && <SharePopup onClickClose={() => setPopup(0)} />}
    </ErrorBoundary>
  )
}

export default SaleDetailTypeBasic